import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useSuggestInstantPayConfig() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_SUGGEST_INSTANT_PAY, {
    defaultValue: {
      cooldownInDays: 7,
      enabled: false,
      recurring: false,
    },
  });
}
